<template>
  <el-dialog
    title="Tạo mới topic"
    :visible="visible"
    width="800px"
    top="50px"
    @close="handleClose"
  >
    <h2 class="mb-xl mt-0">Category: {{ category.name }}</h2>
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="Tên topic" prop="name">
        <el-input
          v-model="form.name"
          :disabled="callingAPI"
          @input="handleGenerateSlug"
          placeholder="Tên topic"
        />
      </el-form-item>
      <el-form-item label="Slug topic" prop="slug">
        <el-input v-model="form.slug" readonly placeholder="" />
      </el-form-item>
      <el-form-item label="Mô tả">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.description"
          :disabled="callingAPI"
          placeholder="Mô tả"
        />
      </el-form-item>
      <el-form-item label="SEO title">
        <el-input
          v-model="form.metaTitle"
          :disabled="callingAPI"
          placeholder="SEO title"
        />
      </el-form-item>
      <el-form-item label="SEO keyword">
        <el-input
          v-model="form.metaKeyword"
          :disabled="callingAPI"
          placeholder="SEO keyword"
        />
      </el-form-item>
      <el-form-item label="SEO description">
        <el-input
          v-model="form.metaDescription"
          :disabled="callingAPI"
          placeholder="SEO description"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI" @click="handleClose">Huỷ</el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        @click="handleManageTopic"
      >
        Xác nhận
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { createCategory, updateCategory } from "@/services/category";

const slugify = require("slugify");
export default {
  name: "CreateTopic",
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    category: {
      type: Object,
      default: () => {},
    },
    currentTopic: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      callingAPI: false,
      searchPosts: "",

      form: {
        name: "",
        slug: "",
        description: "",
        metaTitle: "",
        metaKeyword: "",
        metaDescription: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Tên topic không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    visible() {
      if (this.visible && this.currentTopic) {
        this.form.name = this.currentTopic.name;
        this.form.slug = this.currentTopic.slug;
        this.form.description = this.currentTopic.description;
        this.form.metaTitle = this.currentTopic.meta_itle;
        this.form.metaDescription = this.currentTopic.meta_description;
        this.form.metaKeyword = this.currentTopic.meta_keyword;
      }
    },
  },
  methods: {
    handleGenerateSlug() {
      this.form.slug = slugify(this.form.name);
    },
    async handleManageTopic() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;
            const data = {
              name: this.form.name,
              description: this.form.description,
              slug: this.form.slug,
              meta_title: this.form.metaTitle,
              meta_keyword: this.form.metaKeyword,
              meta_description: this.form.metaDescription,
              parent_id: this.category.id,
            };
            let response = null;
            if (this.currentTopic) {
              response = await updateCategory(this.currentTopic.id, data);
            } else {
              response = await createCategory(data);
            }
            this.callingAPI = false;
            this.handleClose();
            if (response.status == 1) {
              const message = this.$route.params.id
                ? "Cập nhật danh mục thành công."
                : "Thêm danh mục thành công.";
              this.$notify.success({
                title: "Thành công",
                message: message,
                duration: 2000,
              });
            } else {
              this.$notify.error({
                title: "Thất bại",
                message: response.errors[0],
                duration: 2000,
              });
            }
          } catch (error) {
            this.callingAPI = false;

            const message = this.$route.params.id
              ? "Cập nhật danh mục thất bại."
              : "Thêm danh mục thất bại.";
            this.$notify.error({
              title: "Thất bại",
              message: message,
              duration: 2000,
            });
          }
        }
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
